'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  min-height: 36px;\n  width: 100%;\n  border-radius: 2px;\n  background-color: ', ';\n  color: ', ';\n  font-family: ', ';\n  font-size: 13px;\n  display: inline-flex;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n  > div[name=\'header\'] {\n    margin-right: 8px;\n    border-right: 8px solid ', ';\n  }\n  > svg[name=\'headerIcon\'] {\n    font-style: normal;\n    font-size: 18px;\n    margin-top: 9px;\n  }\n  > div[name=\'messageWrapper\'] {\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    > span {\n      font-weight: 500;\n      height: 17px;\n      display: contents;\n      margin: auto 3px auto auto;\n      color: #ffff;\n    }\n    > span[name=\'link\'] {\n      font-weight: 600;\n      text-decoration: underline;\n      cursor: pointer;\n      color: ', ';\n    }\n  }\n  > svg[name=\'closeIcon\'] {\n    width: 8px;\n    font-style: normal;\n    font-size: 11px;\n    cursor: pointer;\n    margin: 13px 12px 0px auto;\n  }\n'], ['\n  min-height: 36px;\n  width: 100%;\n  border-radius: 2px;\n  background-color: ', ';\n  color: ', ';\n  font-family: ', ';\n  font-size: 13px;\n  display: inline-flex;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);\n  > div[name=\'header\'] {\n    margin-right: 8px;\n    border-right: 8px solid ', ';\n  }\n  > svg[name=\'headerIcon\'] {\n    font-style: normal;\n    font-size: 18px;\n    margin-top: 9px;\n  }\n  > div[name=\'messageWrapper\'] {\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    > span {\n      font-weight: 500;\n      height: 17px;\n      display: contents;\n      margin: auto 3px auto auto;\n      color: #ffff;\n    }\n    > span[name=\'link\'] {\n      font-weight: 600;\n      text-decoration: underline;\n      cursor: pointer;\n      color: ', ';\n    }\n  }\n  > svg[name=\'closeIcon\'] {\n    width: 8px;\n    font-style: normal;\n    font-size: 11px;\n    cursor: pointer;\n    margin: 13px 12px 0px auto;\n  }\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _ToastContentBase = require('./ToastContentBase');
var _ToastContentBase2 = _interopRequireDefault(_ToastContentBase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var colorSwitcher = function () {
  function colorSwitcher(theme, type) {
    switch (type) {
      case 'positive':
        return theme.colorHealthGreen;
      case 'cautionary':
        return theme.colorHealthModerate;
      case 'urgent':
        return theme.colorHealthUrgent;
      case 'information':
        return theme.colorPalettePrimaryLight;
      default:
        return theme.colorPalettePrimaryLight;
    }
  }
  return colorSwitcher;
}();

/**
 * Theme Variables Used:
 *  fontFamily
 *  colorHealthGreen
 *  colorHealthModerate
 *  colorPalettePrimaryLight
 *  colorBorderDark
 *  colorPalettePrimaryLight
 */
var ToastContent = (0, _styledComponents2['default'])(_ToastContentBase2['default'])(_templateObject, function (props) {
  return props.theme.colorBorderDark;
}, function (props) {
  return colorSwitcher(props.theme, props.type);
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return colorSwitcher(props.theme, props.type);
}, function (props) {
  return colorSwitcher(props.theme, props.type);
});
exports['default'] = ToastContent;